const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Last Week Icon</title><desc>A picture depicting a square with an arrow pointing down.</desc><path d="M2 20V4a2 2 0 012-2h5v2H4v16h16V4h-5V2h5a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2zm4-2h12v-3H6zm10-9h-3V2h-2v7H8l4 4z"/></svg>';
export {
  t as default
};
